<template>
	<div v-if="alerts && alerts.length > 0" class="alerts-cards-container">
		<AlertCard v-for="(alert, i) in alerts" :key="i" :alert="alert" />
	</div>
	<div v-else-if="!showArchivedAlerts" class="no-alerts-text display-flex flex-column mt-10">
		<div>All good here</div>
		<div>Maybe it's time to write that memoir you've always wanted</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import AlertCard from '@/components/Alerts/AlertCard';
import { getActiveAlerts, getArchivedAlerts } from '@/store/modules/alerts/getters';

export default {
	name: 'UserAlertsTab',
	props: {
		showArchivedAlerts: { type: Boolean, default: false },
	},
	components: {
		AlertCard,
	},
	computed: {
		...mapGetters([getActiveAlerts.fullPath, getArchivedAlerts.fullPath]),
		alerts() {
			if (this.showArchivedAlerts) {
				return this[getArchivedAlerts.fullPath] || [];
			}
			return this[getActiveAlerts.fullPath] || [];
		},
	},
};
</script>

<style scoped lang="scss">
.alerts-cards-container {
	padding-bottom: 30px !important;
}
.no-alerts-text {
	font-weight: 500;
}
</style>
